import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { ICampaignInput } from "@/interfaces/campaign.interface";
import campaignService from "@/services/campaign.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateCampaignProps = UpdateByIdProps<ICampaignInput>;

export type UseUpdateCampaignReturn = {
  update: (props: UpdateCampaignProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateCampaign = (): UseUpdateCampaignReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<ICampaignInput>({
    operation: (formData, campaignId) => campaignService.update(formData, campaignId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateCampaign;
